import {
    CLEAR_MARKETING_CAMPAIGNS,
    SET_MARKETING_CAMPAIGNS,
    SET_ACTIVE_MARKETING_CAMPAIGN,
    SET_ERRORS,
    CLEAR_ERRORS,
    MANAGE_LOADING_MARKETING_CAMPAIGNS,
    MANAGE_REQUESTING_RESOURCE } from './mutation-types.js';

export default {
    [CLEAR_MARKETING_CAMPAIGNS](state) {
         state.marketingCampaigns = [];
    },
    [SET_MARKETING_CAMPAIGNS](state, payload) {
        state.marketingCampaigns.push(payload);
    },
    [SET_ACTIVE_MARKETING_CAMPAIGN](state, payload) {
        state.activeMarketingCampaign = payload;
    },
    [SET_ERRORS](state, payload) {
        state.errors = payload;
    },
    [CLEAR_ERRORS](state) {
        state.errors = null;
    },
    [MANAGE_LOADING_MARKETING_CAMPAIGNS](state, payload) {
        state.loadingMarketingCampaigns = payload;
    },
    [MANAGE_REQUESTING_RESOURCE](state, payload) {
        state.requestingResource = payload;
    }
}